import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import ContentHeader from "../../../components/shared/ContentHeader";
import TopicTable from "./Table";
import AddEditTopicModal from "./AddEditModal";
import { useTenantBranches } from "../../../hooks/useTenantBranches";
import { useTenantTopics } from "../../../hooks/useTenantTopics";

const Topics = () => {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const { branches } = useTenantBranches();
  const { topics, loading } = useTenantTopics();

  const showModal = useCallback((data = null) => {
    //@ts-ignore
    setSelectedTopic(data || {});
  }, []);

  const handleCancel = useCallback(() => {
    setSelectedTopic(null);
  }, []);

  return (
    <div>
      <ContentHeader title={"Topics"}>
        <Button
          type="primary"
          className="add-btn"
          icon={<PlusOutlined />}
          onClick={() => showModal()}
        />
      </ContentHeader>
      <TopicTable topics={topics} showModal={showModal} loading={loading} />
      {selectedTopic && (
        <AddEditTopicModal
          selectedTopic={selectedTopic}
          handleCancel={handleCancel}
          branches={branches}
        />
      )}
    </div>
  );
};

export default Topics;
